// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__6duYk","progressAnimation":"styles_progressAnimation__BQJ8c"};